import React from "react";
import PropTypes from "prop-types";

let VehicleImage = ({ vehicle, image, size }) => {
  if (!image) return null;
  const src = size === "full" ? image.url_full : image.url_thumbnail;
  let alt = `${vehicle?.handle}`;

  return <img className="img-fluid" src={src} alt={alt} />;
};

export default VehicleImage;

VehicleImage.propTypes = {
  image: PropTypes.object,
  alt: PropTypes.string,
  size: PropTypes.string
};
